import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { ActionsService } from '../../services/actions.service';
import { StatusService } from '../../services/status.service';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	loggedIn$: Observable<boolean> = this.loggedIn.asObservable();

	private firebaseAuth: Auth = getAuth(getApps().length ? getApp() : initializeApp(environment.firebase));

	constructor(
		private router: Router,
		private actionsService: ActionsService,
		private statusService: StatusService,
	) { }

	getToken(): string {
		return localStorage.getItem('token') ?? '';
	}

	authenticateFirebase(email: string, password: string): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			signInWithEmailAndPassword(this.firebaseAuth, email, password)
				.then((result) => {
					// .then((user: firebase.auth.UserCredential) => {
					let user = result.user;

					if (user) {
						user.getIdToken().then((token) => {
							window.location.href = `${environment.apiUrlHost}/?type=Other&tokenId=${token}&URL=${window.location.href}`;
						});
					}
				})
				.catch((err) => {
					if (err.code.includes('wrong-password') || err.code.includes('user-not-found')) {
						reject('Wrong username/password');
					}

					if (err.code.includes('too-many-requests')) {
						reject('Too many unsuccesful login attempts. Try again later.');
					}
				});
		});
	}

	login(type: string, remember: boolean) {
		let params = `?type=${type}&URL=${window.location.href}`;

		if (remember) localStorage.setItem('remember', type);

		window.location.href = `${environment.apiUrlHost}/${params}`;
	}

	logout() {
		localStorage.clear();
		signOut(this.firebaseAuth);

		window.location.href = `${environment.apiDomain}/auth/logout`;
	}

	kickSession() {
		if (localStorage.getItem('remember')) {
			localStorage.removeItem('token');
			this.login(localStorage.getItem('remember') ?? '', true);
		} else {
			localStorage.clear();
			this.loggedIn.next(false);
			this.router.navigate(['login'], { queryParamsHandling: "merge" });
		}
	}
}
